import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getTvPrograms as getTvProgramsApi,
  getTvProgramStats as getTvProgramStatsApi,
  scrapeTvPrograms as scrapeTvProgramsApi,
} from "../../helpers/realbackend_helper";

export const getTvPrograms = createAsyncThunk(
  "tvprogram/getTvPrograms",
  async (params, { rejectWithValue }) => {
    try {
      return await getTvProgramsApi(params || {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTvProgramStats = createAsyncThunk(
  "tvprogram/getTvProgramStats",
  async (_, { rejectWithValue }) => {
    try {
      return await getTvProgramStatsApi();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const scrapeTvPrograms = createAsyncThunk(
  "tvprogram/scrapeTvPrograms",
  async (mode, { rejectWithValue }) => {
    try {
      const response = await scrapeTvProgramsApi(mode || "full");
      toast.info("Татаж авах ажиллагаа эхэллээ. Хэдэн минут үргэлжилнэ.", {
        autoClose: 4000,
      });
      return response;
    } catch (error) {
      toast.error("Татаж авахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);
